import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "./App.css";

const App: React.FC = () => {
  useEffect(() => {
    // Google Analytics
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=UA-69575079-2";
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    gtag("js", new Date());
    gtag("config", "UA-69575079-2");

    // Particles.js
    const particlesScript = document.createElement("script");
    particlesScript.src =
      "https://cdnjs.cloudflare.com/ajax/libs/particlesjs/2.2.2/particles.min.js";
    particlesScript.onload = () => {
      if ((window as any).Particles) {
        (window as any).Particles.init({
          selector: ".background",
        });
      }
    };
    document.head.appendChild(particlesScript);

    // Google Fonts — Gaegu (hero), Noto Sans KR (본문)
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Gaegu:wght@400;700&family=Noto+Sans+KR:wght@400;500;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  return (
    <div className="App">
      <a href="#main" className="skip-link">
        본문 바로가기
      </a>

      <main id="main">
        {/* Hero */}
        <section className="hero hero-fullheight" aria-label="회사 소개">
          <div className="hero-body">
            <div className="container text-center">
              <h1 className="hero-title main-color">뜬구름 주식회사</h1>
              <p className="hero-subtitle sub-color">
                뜬구름 잡는 서비스들만 집중적으로 파고드는 회사
              </p>
              <div className="scroll-hint" aria-hidden="true">
                <i className="fa fa-angle-down"></i>
              </div>
            </div>
          </div>
        </section>

        <div className="container">
          {/* COMPANY */}
          <section
            className="section-card"
            aria-labelledby="company-heading"
          >
            <h2 id="company-heading" className="section-heading sub-color">
              <i className="fa fa-search-plus" aria-hidden="true"></i>
              <span>COMPANY</span>
            </h2>
            <div className="row align-items-start">
              <div className="col-12 col-lg-8 mb-3 mb-lg-0">
                <div className="map-wrap">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12661.78740486209!2d127.024526!3d37.4973777!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe718f60c2ca88784!2z67aA652g7YGs66qo64KY7L2U!5e0!3m2!1sko!2sjp!4v1589888513596!5m2!1sko!2sjp"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    title="뜬구름 주식회사 위치 지도"
                  ></iframe>
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <dl className="company-info-list">
                  <dt>회사명</dt>
                  <dd>뜬구름주식회사 (Tgroom, Inc.)</dd>

                  <dt>소재지</dt>
                  <dd>
                    <address>
                      서울시 서초구 서초대로 397
                      <br />
                      부띠끄모나코 A동 908호
                    </address>
                  </dd>

                  <dt>전화번호</dt>
                  <dd>
                    <a href="tel:+82-2-888-6225">02-888-6225</a>
                  </dd>

                  <dt>대표자</dt>
                  <dd>김대원</dd>

                  <dt>이메일</dt>
                  <dd>
                    <a href="mailto:info@tgroom.com">info@tgroom.com</a>
                  </dd>
                </dl>
              </div>
            </div>
          </section>

          {/* WHO */}
          <section className="section-card" aria-labelledby="who-heading">
            <h2 id="who-heading" className="section-heading sub-color">
              <i className="fa fa-question" aria-hidden="true"></i>
              <span>WHO</span>
            </h2>
            <div className="row">
              <div className="col-md-6 mb-4 mb-md-0">
                <article className="profile">
                  <img
                    src="images/d429.jpg"
                    className="profile-img"
                    alt=""
                    width="150"
                    height="150"
                    loading="lazy"
                  />
                  <h3 className="profile-name">
                    김대원
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/daewon.kim.0429"
                      className="social-link"
                      aria-label="김대원의 페이스북 프로필 (새 창)"
                    >
                      <i
                        className="fa fa-facebook-square"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </h3>
                  <p className="profile-meta">한국 거주 · 어쩌다 대표</p>
                  <blockquote className="profile-quote">
                    “일-일-일-휴일필요”
                  </blockquote>
                </article>
              </div>
              <div className="col-md-6">
                <article className="profile">
                  <img
                    src="images/jkang.jpg"
                    className="profile-img"
                    alt=""
                    width="150"
                    height="150"
                    loading="lazy"
                  />
                  <h3 className="profile-name">
                    강정모
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/moya.kang1"
                      className="social-link"
                      aria-label="강정모의 페이스북 프로필 (새 창)"
                    >
                      <i
                        className="fa fa-facebook-square"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </h3>
                  <p className="profile-meta">
                    일본 거주 · 개발 → 산책 → 개발 → 수영
                  </p>
                  <blockquote className="profile-quote">
                    “우리 모두 서로가 서로에게 스승이, 그리고 제자가 됩시다!”
                  </blockquote>
                </article>
              </div>
            </div>
          </section>

          {/* SERVICES */}
          <section
            className="section-card"
            aria-labelledby="services-heading"
          >
            <h2 id="services-heading" className="section-heading sub-color">
              <i className="fa fa-play" aria-hidden="true"></i>
              <span>SERVICES</span>
            </h2>

            <article className="service-item">
              <div className="row align-items-center">
                <div className="col-md-5 mb-3 mb-md-0">
                  <a
                    href="https://www.stepnote.works"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="service-image-link"
                    aria-label="스텝노트 웹사이트 열기 (새 창)"
                  >
                    <img
                      src="images/stepnote-screenshot.png"
                      alt="스텝노트 앱 화면 — 병원 직원 출퇴근, 스케줄, 급여 관리 대시보드"
                      className="service-image"
                      loading="lazy"
                      width="800"
                      height="600"
                    />
                  </a>
                </div>
                <div className="col-md-7">
                  <div className="service-brand">
                    <img
                      src="images/stepnote-logo.png"
                      alt=""
                      className="service-logo"
                      width="48"
                      height="48"
                    />
                    <h3 className="service-name">스텝노트 (StepNote)</h3>
                  </div>
                  <p className="service-badge">
                    치과·병원 통합 관리 솔루션 · 개발 중
                  </p>
                  <p className="service-lead">
                    “원장님은 진료에만 집중하세요. 나머지는 스텝노트가.”
                  </p>
                  <p className="service-desc">
                    직원 출퇴근 기록, 스케줄 관리, 급여 정산까지 한 번에.
                  </p>
                  <a
                    href="https://www.stepnote.works"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="service-cta"
                  >
                    <span>자세히 보기</span>
                    <i
                      className="fa fa-external-link"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
              </div>
            </article>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer id="footer">
        <div className="container">
          <div className="footer-info">
            <p>
              사업자 등록번호 346-81-00282 · 뜬구름 주식회사 · 02-888-6225
            </p>
            <p>
              서울시 서초구 서초대로 397 부띠끄모나코 A동 908호 · 대표자 김성원
            </p>
            <p>
              개인정보책임자 강정모 ·{" "}
              <a href="mailto:j.kang@ttoon.cloud">j.kang@ttoon.cloud</a>
            </p>
            <p>통신판매번호 2015-서울강남-03526호</p>
            <p className="copyright">
              Copyright © {new Date().getFullYear()} Tgroom Co., Ltd. All
              rights reserved.
            </p>
          </div>
        </div>
      </footer>

      <canvas className="background" aria-hidden="true"></canvas>
    </div>
  );
};

export default App;
